import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import useSWR from 'swr';
import { postApi } from '../../apiUtils';
import { useAssetClass } from '../../contexts/assetClass';
import { useBreadcrumbs } from '../../contexts/breadcrumbsContext';
import { useLoading } from '../../contexts/loadingContext';
import { useTranslation } from '../../contexts/translation';
import { StepGroupForm } from '../../forms/stepGroup/StepGroupForm';
import { PageContentWrapper } from '../../layouts/contentWrapper/PageContentWrapper';
import { CapacityCategory } from '../../types/capacityCategory.types';
import { StepGroupInputs } from '../../types/stepGroup.types';
import { API_URL, fetcher } from '../../utils/apiUrl';
import { swrConfig } from '../Assets/AssetsEdit';

export function StepGroupsNew() {
  const { translate } = useTranslation();
  const transFormName = 'StepGroup.Form';
  const { startLoading, stopLoading } = useLoading();
  const { setValue } = useBreadcrumbs();
  const { assetClass } = useAssetClass();
  const history = useHistory();

  useEffect(() => {
    setValue({
      pageName: 'New step group',
      steps: [
        { name: 'Home', pathToCutCount: 3 },
        { name: 'Step groups', pathToCutCount: 2 },
      ],
    });
    return () => {
      setValue(null);
    };
  }, []);

  const formData: StepGroupInputs = {
    id: 0,
    name: '',
    description: '',
    capacityCategoryId: 0,
    visible: true,
  };

  /**
   * Načte seznam capacityCategories.
   */
  const { data: capacityCategories, error: capacityCategoriesError } = useSWR<CapacityCategory[]>(
    `${API_URL.CAPACITY_CATEGORY_LIST}?parentId=${assetClass}`,
    fetcher,
    swrConfig,
  );

  const onSubmit = async (e) => {
    startLoading();
    if (e !== null) e.preventDefault();
    let isOk = false;
    await postApi<StepGroupInputs>({
      url: API_URL.STEP_GROUP_POST,
      data: formData,
      callAfterSuccess: (result) => {
        isOk = true;
        history.push(`/step-groups/edit/${result.id}`);
      },
    });
    stopLoading();
    return isOk;
  };

  return (
    <PageContentWrapper
      heading={translate!('New step group', transFormName)}
      error={capacityCategoriesError}
    >
      <StepGroupForm
        onSubmit={onSubmit}
        formData={formData}
        capacityCategories={capacityCategories}
      />
    </PageContentWrapper>
  );
}

export default StepGroupsNew;
